// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3_kqb","dragIcon":"SortableItem_dragIcon__35cIq","disabled":"SortableItem_disabled__3uOpC"};